export default "__VITE_ASSET__CD0$dYah__"